<template>
  <div class="line-items-body">
    <div class="line-items-body-header d-none d-lg-flex px-i">
      <div class="line-items-body-header-start">
        Sort
      </div>
      <div class="line-items-body-header-end">
        <div class="col-7 line-items-body-header-item">
          Item
        </div>
        <div class="col-3 line-items-body-header-item">
          Quantity
        </div>
        <div v-show="showTaxesDropdown"
             class="col-4 line-items-body-header-item">
          Tax
        </div>
        <div class="line-items-body-header-item"
             :class="{ 'col-4': showTaxesDropdown, 'col-8': !showTaxesDropdown }">
          Price
        </div>
        <div class="col-5 line-items-body-header-item">
          Amount
        </div>
      </div>
    </div>

    <SlickList v-model="lineItems"
               :use-drag-handle="true"
               lock-axis="y"
               class="line-items-body-items"
               append-to=".line-items-body-items"
               :transition-duration="100"
               @sort-start="addCursorStyle()"
               @sort-end="removeCursorStyle()">
      <LineItem v-for="(lineItem, index) in lineItems"
                :key="`line-item-${index}`"
                :line-item="lineItem"
                :index="index"
                @getPaymentPreview="$emit('getPaymentPreview')" />
    </SlickList>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions, mapGetters } from "vuex";

import { SlickList } from "vue-slicksort";

import LineItem from "./LineItem.vue";

export default {
  components: {
    SlickList,
    LineItem
  },

  computed: {
    ...mapFields("lineItems", [
      "lineItems"
    ]),

    ...mapGetters("lineItems", [
      "nonRemovedLineItems",
      "showTaxesDropdown"
    ])
  },

  watch: {
    "nonRemovedLineItems.length" (value) {
      if (value === 0) {
        this.addNewLineItem();
      }
    }
  },

  created () {
    if (this.lineItems.length === 0) {
      this.addNewLineItem();
    }
  },

  methods: {
    ...mapActions("lineItems", [
      "addNewLineItem"
    ]),

    addCursorStyle () {
      document.getElementById("body").style.cursor = "grabbing";
    },

    removeCursorStyle () {
      document.getElementById("body").style.removeProperty("cursor");
    }
  }
};
</script>
